// Note that these constants were defined by the customer.
import {LegalEntityType} from '../models/CustomColumns';
import {PolicyStatus} from '../models/interfaces';
import {formatNumber} from '../util/number-util';

export const MGA_DEFAULT_PAYMENT_DAYS = 14;
export const SALES_CHANNEL = 'Digital';
export const CURRENCY_CODE = 'BRL';
export const SOURCE_SYSTEM_CODE = 'GreenTriangle';
export const SEGMENT_CODE = '0000000003';
export const BRANCH_GROUP = '1111';
export const CATEGORY_CODE = 'pri_portal_000';
export const MOVEMENT_TYPE = '016';
export const TAX_IOF_AMOUNT = '0.0';
export const SUBSIDY_PROGRAM_ID = '2';
export const SAO_PAULO_STATE_CODE = 'SP';
export const MGA_INSURED_PAYMENT_MODE = {
  bankName: 'Itau',
  bankCode: '341',
  paymentMethod: 'BoletoItau',
};
export const MGA_SUBSIDY_PAYMENT_MODE = {
  bankName: 'Itau',
  bankCode: '341',
  paymentMethod: 'OrdemBancaria',
};
export const MGA_PRODUCT_CODE = '15414900048201609';
// External API may return an existing branch office object that represents an unclassified branch office, which
// we need to ignore. Example response:
// { id: 19, branch: 'Não Classificado', status: true, regionalCode: 5, regionalName: 'Não Classificado', regionalStatus: true }
export const UNCLASSIFIED_BRANCH_OFFICE_ID = 19;
// As per discussion with the customer on 2025-06-03, the commission is fixed at 12%.
export const MGA_BROKER_COMMISSION = 12;

export const FEDERAL_SUBSIDY_BASIC_INFORMATION = {
  CodeIdentifier: '00396895000125',
  NomeFantasia: 'Ministério da Agricultura e Pecuária - MAPA',
  CNPJ: '00396895000125',
  LegalName: 'Ministério da Agricultura e Pecuária - MAPA',
};

export const FEDERAL_SUBSIDY_ADDRESS = {
  DPostalCode: '70043900',
  DAddressOne: 'Esplanada dos Ministérios',
  DNumber: 's/n',
  DAddressComplement: 'Bloco D, Edifício Sede',
  DColony: 's/n',
  DCity: 'Brasília',
  DStateCode: 'DF',
  DCountry: 'Brasil',
  DPhone: '(61) 3218-2995',
  DEmail: 'seguro@agro.gov.br',
  StatusEnderecos: 'Ativo',
  TipoEnderecoVisi: 'Endereço Comercial',
};

export const SAO_PAOLO_STATE_SUBSIDY_BASIC_INFORMATION = {
  CodeIdentifier: '46384400000149',
  NomeFantasia: 'SECRETARIA DE AGRICULTURA E ABASTECIMENTO',
  CNPJ: '46384400000149',
  LegalName: 'SECRETARIA DE AGRICULTURA E ABASTECIMENTO',
};

export const SAO_PAOLO_STATE_SUBSIDY_ADDRESS = {
  DPostalCode: '01037912',
  DAddressOne: 'PRACA RAMOS DE AZEVEDO',
  DNumber: '254',
  DAddressComplement: '7 andar',
  DColony: 'Centro',
  DCity: 'São Paulo',
  DStateCode: 'SP',
  DCountry: 'Brasil',
  DPhone: '(11) 5067-0051',
  DEmail: 'planejamento.agricultura@sp.gov.br',
  StatusEnderecos: 'Ativo',
  TipoEnderecoVisi: 'Endereço Comercial',
};

// eCampo can't separate basic and replanting premiums and for that reason, we hardcode the replanting
// premium rate percent (at 5%), so the replanting premium can always be calculated.
export const MGA_REPLANTING_PREMIUM_RATE_PERCENT = 5;

export const PREVIOUS_CULTURE = 'Cultura anterior?';
export const PLANTING_SYSTEM = 'Qual sistema de plantio?';
export const CROP_ALREADY_PLANTED = 'Lavoura já está plantada?';
export const ZONING_RECOMMENDATIONS = 'Utilizou recomendação de zoneamento?';
export const SAME_CULTURE_ENTIRE_AREA = 'Mesma cultura para toda área?';
export const OTHER_INSURANCE = 'Área declarada possui outro seguro?';
export const TOTAL_AREA_INSURED = 'Área total plantada será segurada?';
export const FIRST_OR_SECOND_YEAR_HARVEST = 'Lavoura implantada em área de 1ª e 2ª ano de plantio de grãos?';
export const ALREADY_DAMAGED =
  'Caso a lavoura já esteja implantada, possui danos ocasionados pelo(s) evento(s) coberto(s) por esta apólice?';
export const AD1_AD2_SOIL = 'Área a ser segurada possui predominância (mais de 50%) de solos AD1 e/ou AD2?';
export const CROP_IRRIGATED = 'Lavoura é irrigada?';

export const MGA_WARNING_STYLE = {
  padding: '5px',
  backgroundColor: '#fff9db',
  border: '2px solid #ffeb3b',
  color: '#fbc02d',
  borderRadius: '5px',
};

export const MGA_OK_STYLE = {
  padding: '5px',
  backgroundColor: '#e0f7e9',
  border: '2px solid #4caf50',
  color: '#388e3c',
  borderRadius: '5px',
};

export const MGA_ERROR_STYLE = {
  padding: '5px',
  backgroundColor: '#fde0e0',
  border: '2px solid #f44336',
  color: '#d32f2f',
  borderRadius: '5px',
};

export function getPaymentDays(paymentSlipIndex: number) {
  return 10 + 30 * paymentSlipIndex;
}

export function formatBraCurrency(input: number) {
  return 'R$ ' + formatBraNumber(input, true, true);
}

export function formatBraNumber(input: number, isCurrency: boolean, useGrouping: boolean): string;
export function formatBraNumber(input: null | undefined, isCurrency: boolean, useGrouping: boolean): null;
export function formatBraNumber(
  input: null | undefined | number,
  isCurrency: boolean,
  useGrouping: boolean,
): null | string;
export function formatBraNumber(
  input: null | undefined | number,
  isCurrency: boolean,
  useGrouping: boolean,
): null | string {
  return formatNumber('pt-BR', input, isCurrency, useGrouping);
}
export function formatBraPhoneNumber(phone: null | undefined | string): null | string {
  if (!phone) {
    return null;
  } else if (phone.length === 10) {
    // Landline: (XX) XXXX-XXXX
    return phone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  } else if (phone.length === 11) {
    // Mobile: (XX) 9XXXX-XXXX
    return phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  }
  return phone;
}
export function formatBraZipcode(zipcode: null | undefined | string): null | string {
  if (!zipcode) {
    return null;
  }
  if (zipcode.length !== 8) {
    return zipcode;
  }
  return zipcode.replace(/(\d{5})(\d{3})/, '$1-$2');
}

export function formatBraDocumentNumber(
  documentNumber: null | undefined | string,
  type: null | LegalEntityType,
): null | string {
  if (!documentNumber) {
    return null;
  }
  switch (type) {
    case 'person':
      if (documentNumber.length !== 11) {
        return documentNumber;
      }
      // Format: 000.000.000-00
      return documentNumber.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    case 'company':
      if (documentNumber.length !== 14) {
        return documentNumber;
      }
      // Format: 00.000.000/0000-00
      return documentNumber.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    default:
      return documentNumber;
  }
}

// IMPORTANT: if the policy's status is policy, and it was last modified before 2025-06-16T14:48:00Z, then we need to
// skip the insured yield rounding to match the PDF documents that were created before the calculation changed.
// After that time, the customer decided to round the insured yield to 2 decimals, but we need to keep the
// policies created up to that point keep the same value. The sum insured and premiums are recalculated everytime the
// web app reloads, and thus we must be very careful when changing the calculation logic. 2025-06-16T14:48:00Z is the
// time we deployed the new calculation to production via release-2025.1.24.1.
export function braPolicySkipInsuredYieldRounding(policy_updated_at: null | string, status: PolicyStatus) {
  return status === 'policy' && !!policy_updated_at && new Date(policy_updated_at) < new Date('2025-06-16T14:48:00Z');
}
